export default {
	state: {
		plano: {}
	},
	getters: {
		"plano": state => state.plano
	},
	mutations: {
		setPlano(state, payload) {
			state.plano = payload
		}
	},
	actions: {
		atualizarEstadoPlano({ commit }, payload) {
			commit('setPlano', payload)
		}
	}
};